<template>
  <AppSection id="help-center-page" :title="$t($getConst.pages.permission.select_role)" type="page" class="mt-5">

    <b-row class="justify-content-center mt-5">
      <b-col
        xl="3" lg="4" md="4" sm="6"
        class="pb-4"
      >
        <AppPageOptionBox
          :icon="$getConst.svgIcons.approver"
          :text="$t($getConst.pages.permission.connect_as_approver)"
          @onClick="connectAs('Approver')"
          :is-active="$store.getters['auth/connectedRole'] === 'Approver'"
        />
      </b-col>

      <b-col
        xl="3" lg="4" md="4" sm="6"
        class="pb-4"
      >
        <AppPageOptionBox
          :icon="$getConst.svgIcons.worker"
          :text="$t($getConst.pages.permission.connect_as_worker)"
          @onClick="connectAs('Worker')"
          :is-active="$store.getters['auth/connectedRole'] === 'Worker'"
        />
      </b-col>
    </b-row>

  </AppSection>


</template>

<script>
  import AppSection from "../../components/common/sections/AppSection";
  import AppPageOptionBox from "../../components/common/utils/AppPageOptionBox";

  export default {
    name: "index",
    components: {AppPageOptionBox, AppSection},
    methods: {
      connectAs(role) {
        this.$store.dispatch("auth/updateConnectedRole", role);
        this.$router.push("/timesheets");
      }
    }
  }
</script>

<style scoped>

</style>
